import { Actor, Keys, Scene, SpriteSheet, TileMap, Vector } from "excalibur";

import { inventoryState } from "../state/stateManager";
import { checkFilledJars, createGainedItem, sendAlert } from "../utils";
import { goToScene } from "../main";
import BottlingAnimation from "../actors/BottlingAnimation";
import { Resources } from "../Resources";
export default class Bottling extends Scene {
  constructor() {
    super();
    this.bottling = new BottlingAnimation();
    this.bottling.scale = new Vector(4, 4);
    this.add(this.bottling);
    this.ui = document.getElementById("extraction");
  }

  onActivate() {
    this.inventory = inventoryState.getInventory();
    this.ui.style.display = "flex";
    this.ui.innerHTML = `<h1>Honey Buckets: ${parseFloat(
      this.inventory.buckets
    ).toFixed(2)}</h1><h1>Filled Jars: ${
      this.inventory.filledJars
    }</h1><p>Use Down Key To Fill Jars</p><p>X> BACK</p>`;
  }
  onInitialize(engine) {
    this.inventory = inventoryState.getInventory();
    this.engine = engine;
  }
  bottled() {
    this.inventory.buckets = this.inventory.buckets - 0.017;
    if (this.inventory.buckets < 0) {
      this.inventory.buckets = 0;
    }
    this.inventory.filledJars = this.inventory.filledJars + 1;
    this.ui.innerHTML = `<h1>Honey Buckets: ${parseFloat(
      this.inventory.buckets
    ).toFixed(2)}</h1><h1>Filled Jars: ${
      this.inventory.filledJars
    }</h1><p>Use Down Key To Fill Jars</p><p>X> BACK</p>`;
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      if (this.inventory.buckets > 0.016) {
        this.bottling.doAnim("bottle");
        checkFilledJars();
        Resources.Liquid.play();
        this.bottled();
      } else {
        sendAlert("No Honey To Bottle");
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      goToScene("honeyHouse");
    }
  }
  onDeactivate() {
    this.ui.style.display = "none";
  }
}
